import React from 'react';
import { ShieldCheckIcon, TruckIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="px-4 py-8 md:py-12" data-id="element-13">
      <div className="max-w-2xl mx-auto text-center" data-id="element-14">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8" data-id="element-15">
          Try Alpha Gummies Risk-Free Today
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-16">
          <div className="flex flex-col items-center" data-id="element-17">
            <ShieldCheckIcon size={48} className="text-orange-500 mb-3" data-id="element-18" />
            <h3 className="font-bold text-lg mb-2" data-id="element-19">60-Day Guarantee</h3>
            <p className="text-gray-700 text-sm" data-id="element-20">
              Not satisfied? Get a full refund, no questions asked
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-21">
            <TruckIcon size={48} className="text-orange-500 mb-3" data-id="element-22" />
            <h3 className="font-bold text-lg mb-2" data-id="element-23">Free Shipping</h3>
            <p className="text-gray-700 text-sm" data-id="element-24">
              On all orders within the United States
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-25">
            <CreditCardIcon size={48} className="text-orange-500 mb-3" data-id="element-26" />
            <h3 className="font-bold text-lg mb-2" data-id="element-27">Secure Checkout</h3>
            <p className="text-gray-700 text-sm" data-id="element-28">
              Your information is always protected
            </p>
          </div>
        </div>
        <div className="bg-orange-100 p-6 rounded-lg mb-8" data-id="element-29">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mn1Xu2vcweMFrLdDf9PxZ4/1.png" alt="PureNutra Alpha Gummies product" className="mx-auto rounded-lg shadow-md max-w-xs mb-4" data-id="element-30" />
          <p className="font-bold text-lg text-gray-900 mb-2" data-id="element-31">
            Limited Time Offer!
          </p>
          <p className="text-gray-800 mb-4" data-id="element-32">
            Get 50% off when you order today + Buy 2 Get 1 FREE!
          </p>
          <CTAButton data-id="element-33" />
        </div>
        <p className="text-sm text-gray-500" data-id="element-34">
          *These statements have not been evaluated by the Food and Drug
          Administration. This product is not intended to diagnose, treat, cure,
          or prevent any disease.
        </p>
      </div>
    </section>;
}